const IS_NW = !!window.nw;

export const WORLD_STORE_URL = 'https://world.store.screeps.com';
export const STEAM_ITEM_SHOP_URL = 'https://store.steampowered.com/itemstore/464350/browse/?filter=All';
export const STEAM_CPU_LIFETIME_URL = 'https://store.steampowered.com/app/883940/Screeps__Lifetime_CPU_Subscription/';
export const STEAM_UNLIMITED_ACCESS_URL = 'https://store.steampowered.com/app/4507040';

export const ITEM_SHOP_URL = IS_NW ? STEAM_ITEM_SHOP_URL : WORLD_STORE_URL;
export const CPU_LIFETIME_STORE_URL = IS_NW ? STEAM_CPU_LIFETIME_URL : WORLD_STORE_URL;
export const UNLIMITED_ACCESS_STORE_URL = IS_NW ? STEAM_UNLIMITED_ACCESS_URL : WORLD_STORE_URL;
